import { createFileRoute } from '@tanstack/react-router'
import { useSuspenseQuery } from '@tanstack/react-query'
import { trpc } from '@/main'
import { useOffer } from '@/hooks/use-offer'
import { BoardPending } from './-components/shared/board-pending'
import { Board } from './-components/shared/board'
import { EmptyState } from './-components/shared/empty-state'
import { GroupContextProvider } from './-components/shared/group-context'

export const Route = createFileRoute('/_app/offers/$offerId/board')({
  loaderDeps: ({ search }) => ({ type: search.type }),
  loader: ({ context, deps, params }) => {
    context.queryClient.prefetchQuery(
      trpc.companies.getOfferApplicantIndicators.queryOptions({ offerId: Number(params.offerId), type: deps.type }),
    )
  },
  component: RouteComponent,
  pendingComponent: BoardPending,
})

function RouteComponent() {
  const { offerId } = Route.useParams()
  const { offerApplicants } = useOffer(Number(offerId))
  const { data: offer } = useSuspenseQuery(trpc.jobs.getJob.queryOptions({ jobId: Number(offerId) }))

  const members = (offerApplicants?.members ?? []).map((member) => ({
    ...member,
    id: member.id,
  }))

  if (offerApplicants?.emptyStateCode) {
    return <EmptyState code={offerApplicants.emptyStateCode} surface="board" />
  }

  return (
    <GroupContextProvider type="offer">
      <Board name={offer?.name ?? ''} profiles={members} standardIndicators={offerApplicants?.indicators} />
    </GroupContextProvider>
  )
}
